export class ExportReadyModel {
    public url: string;
    public mode: number;
   

    constructor(url: string, mode: number) {
        this.url = url;
        this.mode = mode;
       
    };
};